/* eslint-disable */
import settings from "../../../configs/settings";
import { v4 as uuidv4 } from "uuid";
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/system";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useContext, useEffect, useState } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import BuscarTratamientoDialog from "./BuscarTratamientoDialog";
import { getTratamiento } from "../../../project/services/TratamientoService";
import { getPorcentajeDescuento } from "../../../project/services/ArticuloService";
import Message from "../../../project/utils/Message";
import { formatMoney } from "../../utils/utils"
import { limpiaCodigo } from "../../utils/utils";
import WaitingDialog from "../../utils/WaitingDialog";

//
// ################################################################################
//
const AnteojoTratamientos = () => {
  const [openDialogBusquedaAvanzada, setOpenDialogBusquedaAvanzada] = useState(false);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const {
    anteojoTratamientosOjoOptions,
    initialAnteojoTratamiento,
    anteojoTratamiento,
    handleChangeAnteojoTratamiento,
    setAnteojoTratamiento,
    anteojoCristales,
    anteojoTratamientosRows,
    setAnteojoTratamientosRows,
    totalAnteojoTratamientos,
    totalAnteojoTratamientosContado,
    gaAction,
  } = useContext(GestionAtencionContext);
  let {
    anteojoTratamientoOjo,
    anteojoTratamientoCodigo,
    anteojoTratamientoDescripcion,
    anteojoTratamientoPrecioVenta,
    anteojoTratamientoPorcentajeDescuento,
    anteojoTratamientoPrecioVentaContado,
  } = anteojoTratamiento;
  let { anteojoCristalesSelectedCristalOD, anteojoCristalesSelectedCristalOI } = anteojoCristales;
  const [disabledTratamientos, setDisabledTratamientos] = useState(true);
  const [ojoValidOptions, setOjoValidOptions] = useState(anteojoTratamientosOjoOptions);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);

  const tableColumns = [
    {
      field: "anteojoTratamientoOjo",
      headerName: "Ojo",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.anteojoTratamientoOjo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "anteojoTratamientoCodigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.anteojoTratamientoCodigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "anteojoTratamientoDescripcion",
      headerName: "Tratamiento",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.anteojoTratamientoDescripcion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "anteojoTratamientoPrecioVenta",
      headerName: "Prc Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.anteojoTratamientoPrecioVenta;
        _val = _val ? _val : 0;
        return _val.toFixed(2);
      },
    },
    {
      field: "anteojoTratamientoPrecioVentaContado",
      headerName: "Prc Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.anteojoTratamientoPrecioVentaContado;
        _val = _val ? _val : 0;
        return _val.toFixed(2);
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {gaAction.cu !== "view" && (
            <Tooltip title="quitar tratamiento">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleClickActionTratamiento(params.row)}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  // cuando el usuario cambia la opcion de ojo o cuando selecciona o deselecciona un cristal para
  // ojo derecho o izquierdo
  useEffect(() => {
    let _ojoOptionsTmp = [];

    _ojoOptionsTmp = anteojoTratamientosOjoOptions.map((item) => {
      if (anteojoCristalesSelectedCristalOD) {
        if (item.id === "derecho") {
          return item;
        }
      }
      if (anteojoCristalesSelectedCristalOI) {
        if (item.id === "izquierdo") {
          return item;
        }
      }
      if (anteojoCristalesSelectedCristalOD && anteojoCristalesSelectedCristalOI) {
        if (item.id === "ambos") {
          return item;
        }
      }
      return null;
    });

    _ojoOptionsTmp = _ojoOptionsTmp.filter((item) => item !== null);
    setOjoValidOptions(_ojoOptionsTmp);

    if (_ojoOptionsTmp.length === 0) {
      // si no hay cristal derecho ni izquierdo seleccionado
      setAnteojoTratamiento(initialAnteojoTratamiento);
      setDisabledTratamientos(true);
    } else {
      setDisabledTratamientos(false);
    }
  }, [
    anteojoTratamientosOjoOptions,
    anteojoCristalesSelectedCristalOD,
    anteojoCristalesSelectedCristalOI,
    initialAnteojoTratamiento,
    setAnteojoTratamiento,
  ]);
  //
  // ################################################################################
  //
  const handleClickActionTratamiento = (parRow) => {
    if (parRow === undefined) {
      // si estoy agregando un tratamiento

      let _tratamientoRepetido = false;
      anteojoTratamientosRows.forEach((item) => {
        if (
          item.anteojoTratamientoOjo === anteojoTratamiento.anteojoTratamientoOjo &&
          item.anteojoTratamientoCodigo === anteojoTratamiento.anteojoTratamientoCodigo
        ) {
          _tratamientoRepetido = true;
        }
      });

      if (_tratamientoRepetido) {
        setMessage({
          messageText: "Ya agregaste este tratamiento para el ojo seleccionado",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      if (anteojoTratamiento.anteojoTratamientoOjo === "ambos") {
        // si el vendedor selecciono el tratatamiento para ambos ojos

        let _anteojoTratamientosRowsTmp = [];
        if (
          !anteojoTratamientosRows.some(
            (item) =>
              item.anteojoTratamientoOjo === "izquierdo" &&
              item.anteojoTratamientoCodigo === anteojoTratamiento.anteojoTratamientoCodigo
          )
        ) {
          // si el tratamiento no esta agregado para el ojo derecho, lo agrego

          let _tratamientoOjoIzquierdo = {
            id: uuidv4(),
            anteojoTratamientoId: anteojoTratamiento.anteojoTratamientoId,
            anteojoTratamientoOjo: "izquierdo",
            anteojoTratamientoCodigo: anteojoTratamiento.anteojoTratamientoCodigo,
            anteojoTratamientoDescripcion: anteojoTratamiento.anteojoTratamientoDescripcion,
            anteojoTratamientoPrecioVenta: anteojoTratamiento.anteojoTratamientoPrecioVenta,
            anteojoTratamientoPrecioVentaOriginal:
              anteojoTratamiento.anteojoTratamientoPrecioVentaOriginal,
            anteojoTratamientoPorcentajeDescuento:
              anteojoTratamiento.anteojoTratamientoPorcentajeDescuento,
            anteojoTratamientoPrecioVentaContado:
              anteojoTratamiento.anteojoTratamientoPrecioVentaContado,
          };
          _anteojoTratamientosRowsTmp.push(_tratamientoOjoIzquierdo);
        }

        if (
          !anteojoTratamientosRows.some(
            (item) =>
              item.anteojoTratamientoOjo === "derecho" &&
              item.anteojoTratamientoCodigo === anteojoTratamiento.anteojoTratamientoCodigo
          )
        ) {
          // si el tratamiento no esta agregado para el ojo derecho, lo agrego

          let _tratamientoOjoDerecho = {
            id: uuidv4(),
            anteojoTratamientoId: anteojoTratamiento.anteojoTratamientoId,
            anteojoTratamientoOjo: "derecho",
            anteojoTratamientoCodigo: anteojoTratamiento.anteojoTratamientoCodigo,
            anteojoTratamientoDescripcion: anteojoTratamiento.anteojoTratamientoDescripcion,
            anteojoTratamientoPrecioVenta: anteojoTratamiento.anteojoTratamientoPrecioVenta,
            anteojoTratamientoPrecioVentaOriginal:
              anteojoTratamiento.anteojoTratamientoPrecioVentaOriginal,
            anteojoTratamientoPorcentajeDescuento:
              anteojoTratamiento.anteojoTratamientoPorcentajeDescuento,
            anteojoTratamientoPrecioVentaContado:
              anteojoTratamiento.anteojoTratamientoPrecioVentaContado,
          };
          _anteojoTratamientosRowsTmp.push(_tratamientoOjoDerecho);
        }
        setAnteojoTratamientosRows([...anteojoTratamientosRows, ..._anteojoTratamientosRowsTmp]);
      } else {
        // si el vendedor selecciono el tratatamiento para ojo izquierdo o para ojo derecho
        let _tratamiento = {
          id: uuidv4(),
          anteojoTratamientoId: anteojoTratamiento.anteojoTratamientoId,
          anteojoTratamientoOjo: anteojoTratamiento.anteojoTratamientoOjo,
          anteojoTratamientoCodigo: anteojoTratamiento.anteojoTratamientoCodigo,
          anteojoTratamientoDescripcion: anteojoTratamiento.anteojoTratamientoDescripcion,
          anteojoTratamientoPrecioVenta: anteojoTratamiento.anteojoTratamientoPrecioVenta,
          anteojoTratamientoPrecioVentaOriginal:
            anteojoTratamiento.anteojoTratamientoPrecioVentaOriginal,
          anteojoTratamientoPorcentajeDescuento:
            anteojoTratamiento.anteojoTratamientoPorcentajeDescuento,
          anteojoTratamientoPrecioVentaContado:
            anteojoTratamiento.anteojoTratamientoPrecioVentaContado,
        };
        setAnteojoTratamientosRows([...anteojoTratamientosRows, _tratamiento]);
      }
      setAnteojoTratamiento(initialAnteojoTratamiento);
    } else {
      // si estoy eliminando un tratamiento

      let _tratamientosRows = anteojoTratamientosRows.filter(
        (item) => item.id !== parRow.id
      );
      setAnteojoTratamientosRows(_tratamientosRows);
    }
  };
  //
  // ################################################################################
  //
  const handleBuscarTratamiento = () => {
    if (anteojoTratamientoCodigo === "") {
      return;
    }

    const buscarTratamiento = async () => {

      const _anteojoTratamientoCodigo = limpiaCodigo(anteojoTratamientoCodigo).toUpperCase();

      setAnteojoTratamiento({
        ...anteojoTratamiento,
        anteojoTratamientoCodigo: _anteojoTratamientoCodigo,
      });

      setIsDoingSomething(true);
      const response = await getTratamiento(_anteojoTratamientoCodigo);
      setIsDoingSomething(false);

      if (response.ok) {
        let _params = {
          tipoArticulo: "tratamiento",
          id: response.data.data[0].id_tr_marca,
        };

        setIsDoingSomething(true);
        const responseDescuento = await getPorcentajeDescuento(_params);
        setIsDoingSomething(false);

        let _porcentajeDescuento = 0;
        if (responseDescuento.ok) {
          _porcentajeDescuento = responseDescuento.data.data.porcentaje_descuento;
        }
        let _precioVentaContado =
          response.data.data[0].precio_venta_lista -
          (response.data.data[0].precio_venta_lista * _porcentajeDescuento) / 100;

        let _tratamiento = {
          anteojoTratamientoId: response.data.data[0].id,
          anteojoTratamientoOjo: anteojoTratamientoOjo,
          anteojoTratamientoCodigo: response.data.data[0].codigo,
          anteojoTratamientoDescripcion: response.data.data[0].descripcion,
          anteojoTratamientoPrecioVenta: response.data.data[0].precio_venta_lista,
          anteojoTratamientoPrecioVentaOriginal: response.data.data[0].precio_venta_lista,
          anteojoTratamientoPorcentajeDescuento: _porcentajeDescuento,
          anteojoTratamientoPrecioVentaContado: _precioVentaContado,
        };
        setAnteojoTratamiento(_tratamiento);
      } else {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
        setAnteojoTratamiento(initialAnteojoTratamiento);
      }
    };

    buscarTratamiento();
  };
  //
  // ################################################################################
  //
  const handleClickOpenBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(true);
  };
  //
  // ################################################################################
  //
  const handleCloseBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(false);
  };
  //
  // ################################################################################
  //
  const handleSelectBusquedaAvanzada = async (articulo) => {
    setOpenDialogBusquedaAvanzada(false);

    let _params = {
      tipoArticulo: "tratamiento",
      id: articulo.id_tr_marca,
    };

    const response = await getPorcentajeDescuento(_params);
    let _porcentajeDescuento = 0;
    if (response.ok) {
      _porcentajeDescuento = response.data.data.porcentaje_descuento;
    }
    let _precioVentaContado =
      articulo.precio_venta_lista - (articulo.precio_venta_lista * _porcentajeDescuento) / 100;

    let _tratamiento = {
      anteojoTratamientoId: articulo.id,
      anteojoTratamientoOjo: anteojoTratamientoOjo,
      anteojoTratamientoCodigo: articulo.codigo,
      anteojoTratamientoDescripcion: articulo.descripcion,
      anteojoTratamientoPrecioVenta: articulo.precio_venta_lista,
      anteojoTratamientoPrecioVentaOriginal: articulo.precio_venta_lista,
      anteojoTratamientoPorcentajeDescuento: _porcentajeDescuento,
      anteojoTratamientoPrecioVentaContado: _precioVentaContado,
    };
    setAnteojoTratamiento(_tratamiento);
  };
  //
  // ################################################################################
  //
  const handleLimpiarTratamiento = () => {
    setAnteojoTratamiento(initialAnteojoTratamiento);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Box sx={{ mx: 1, px: 1, pb: 1 }}>
        {gaAction.cu !== "view" && (
          <>
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>

                  {/* tratamiento para ojo */}

                  <FormControl fullWidth disabled={disabledTratamientos} sx={{ mb: 1 }}>
                    <InputLabel id="ojo-select-label">Tratamiento para ojo ...</InputLabel>
                    <Select
                      labelId="ojo-select-label"
                      label="Tratamiento para ojo ..."
                      id="ojo-select"
                      name="anteojoTratamientoOjo"
                      value={anteojoTratamientoOjo}
                      size="small"
                      onChange={handleChangeAnteojoTratamiento}
                    >
                      {ojoValidOptions.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1}>
                <Grid item md={6}>
                  {/* codigo de tratamiento */}

                  <TextField
                    sx={{ mb: 1 }}
                    id="anteojoTratamientoCodigo"
                    label="Código del Tratamiento"
                    variant="outlined"
                    size="small"
                    name="anteojoTratamientoCodigo"
                    value={anteojoTratamientoCodigo}
                    onChange={handleChangeAnteojoTratamiento}
                    disabled={anteojoTratamientoDescripcion !== "" || disabledTratamientos}
                  />
                </Grid>

                <Grid item md={6}>
                  {/* boton buscar */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    onClick={handleBuscarTratamiento}
                    startIcon={<SearchIcon />}
                    disabled={
                      anteojoTratamientoCodigo === "" || anteojoTratamientoDescripcion !== ""
                    }
                  >
                    Buscar
                  </Button>

                  {/* boton busqueda avanzada */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    onClick={handleClickOpenBusquedaAvanzada}
                    startIcon={<SavedSearchIcon />}
                    disabled={disabledTratamientos}
                  >
                    Búsqueda Avanzada
                  </Button>

                  {/* boton limpiar */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="outlined"
                    onClick={handleLimpiarTratamiento}
                    startIcon={<CleaningServicesIcon />}
                    disabled={anteojoTratamientoCodigo === ""}
                  >
                    Limpiar
                  </Button>
                </Grid>
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={12} md={6} sx={{ mb: 1 }}>
                  {/* descripcion del tratamiento */}

                  <TextField
                    sx={{ width: "100%" }}
                    id="anteojoTratamientoDescripcion"
                    label="Descripción"
                    variant="outlined"
                    size="small"
                    name="anteojoTratamientoDescripcion"
                    value={anteojoTratamientoDescripcion}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  {/* precio de lista  */}

                  <TextField
                    sx={{ width: "70%" }}
                    inputProps={{ style: { textAlign: "right" } }}
                    id="anteojoTratamientoPrecioVenta"
                    label="Precio de lista"
                    variant="outlined"
                    size="small"
                    name="anteojoTratamientoPrecioVenta"
                    value={anteojoTratamientoPrecioVenta.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  {/* precio de contado */}

                  <TextField
                    sx={{ width: "70%" }}
                    inputProps={{ style: { textAlign: "right" } }}
                    id="anteojoTratamientoPrecioVentaContado"
                    label="Precio de contado"
                    variant="outlined"
                    size="small"
                    name="anteojoTratamientoPrecioVentaContado"
                    value={anteojoTratamientoPrecioVentaContado.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>

                  {/* boton agregar */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    disabled={
                      disabledTratamientos ||
                      anteojoTratamientoOjo === "" ||
                      anteojoTratamientoCodigo === "" ||
                      anteojoTratamientoDescripcion === ""
                    }
                    onClick={() => handleClickActionTratamiento()}
                    startIcon={<AddCircleOutlineOutlinedIcon />}
                  >
                    Agregar
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </>
        )}

        <Grid container spacing={1}>
          <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
            <DataGrid
              rows={anteojoTratamientosRows}
              columns={tableColumns}
              {...tableOptions}
            />
          </Grid>

          <Grid item sm={6}>
            <Typography
              component="div"
              align="right"
              sx={{
                p: 1,
                mt: 2,
                backgroundColor: "LightBlue",
                borderRadius: "5px",
                fontWeight: "bold",
              }}
            >
              PRECIO DE LISTA: {formatMoney(totalAnteojoTratamientos)}
            </Typography>
          </Grid>
          <Grid item sm={6}>
            <Typography
              component="div"
              align="right"
              sx={{
                p: 1,
                mt: 2,
                backgroundColor: "LightBlue",
                borderRadius: "5px",
                fontWeight: "bold",
              }}
            >
              PRECIO DE CONTADO: {formatMoney(totalAnteojoTratamientosContado)}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {openDialogBusquedaAvanzada && (
        <BuscarTratamientoDialog
          open={openDialogBusquedaAvanzada}
          onClose={handleCloseBusquedaAvanzada}
          onSelect={handleSelectBusquedaAvanzada}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default AnteojoTratamientos;